export const testimonials = [
  {
    id: '1',
    name: '张伟',
    role: '本地居民',
    content: '自从有了凤楼信息，我对周边的动态了如指掌。从社区活动到商业资讯，信息更新及时，内容质量高。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20business%20casual%20style%2C%20warm%20lighting%2C%20headshot%20photography&width=200&height=200&seq=avatar-1&orientation=squarish',
    rating: 5,
  },
  {
    id: '2',
    name: '李梅',
    role: '创业者',
    content: '作为一个在凤楼创业的人，这个平台提供的商务资讯和市场分析对我的业务决策帮助很大，省去了大量搜集信息的时间。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%2C%20confident%20expression%2C%20clean%20white%20background%2C%20modern%20business%20attire%2C%20warm%20lighting%2C%20headshot%20photography&width=200&height=200&seq=avatar-2&orientation=squarish',
    rating: 5,
  },
  {
    id: '3',
    name: '王建国',
    role: '退休教师',
    content: '退休后喜欢到处走走，凤楼信息的旅游板块给了我很多出行灵感。推荐的景点和路线都非常靠谱，图文并茂。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20elderly%20Chinese%20man%20portrait%2C%20kind%20smile%2C%20clean%20white%20background%2C%20casual%20style%2C%20natural%20lighting%2C%20headshot%20photography&width=200&height=200&seq=avatar-3&orientation=squarish',
    rating: 4,
  },
  {
    id: '4',
    name: '陈小婷',
    role: '美食博主',
    content: '作为一个美食内容创作者，凤楼信息的美食探店板块给了我很多灵感和素材。文章质量高，信息准确。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20portrait%2C%20bright%20smile%2C%20clean%20white%20background%2C%20fashionable%20casual%20style%2C%20warm%20lighting%2C%20headshot%20photography&width=200&height=200&seq=avatar-4&orientation=squarish',
    rating: 5,
  },
  {
    id: '5',
    name: '刘强',
    role: 'IT工程师',
    content: '科技板块的内容很专业，不是那种标题党，而是有深度的行业分析。对于关注科技动态的人来说是很好的信息源。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20thoughtful%20expression%2C%20clean%20white%20background%2C%20smart%20casual%20style%2C%20warm%20lighting%2C%20headshot%20photography&width=200&height=200&seq=avatar-5&orientation=squarish',
    rating: 4,
  },
  {
    id: '6',
    name: '赵丽华',
    role: '全职妈妈',
    content: '本地生活板块是我每天必看的，孩子的活动信息、社区动态、生活小贴士都很实用。推荐给了很多朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20Chinese%20female%20portrait%2C%20warm%20smile%2C%20clean%20white%20background%2C%20casual%20home%20style%2C%20natural%20lighting%2C%20headshot%20photography&width=200&height=200&seq=avatar-6&orientation=squarish',
    rating: 5,
  },
];